import React from "react";
import * as S from "./NavBar.style";

function NavBar() {
  return (
    <div>
      <S.Container>
        <S.Link href="#Politicadeprivacidade">Aviso de privacidade</S.Link>
        <S.Link href="#Políticadecookies">Política de cookies</S.Link>
        <S.Link href="#Personalizarcookies">Personalizar cookies</S.Link>
        <S.Link href="#Seusdireitos">Seus direitos</S.Link>
        <S.Link href="#Exercaseusdireitos">Exerça seus direitos</S.Link>
        <S.Link href="#ParaExercerSeusDireitos">Para exercer seus direitos</S.Link>
        <S.Link href="#TransferenciaInternacional">Transferência internacional de dados pessoais</S.Link>
      </S.Container>
    </div>
  );
}

export default NavBar;
